import folderStore, { addNewFolderToStore, folderHasChildWithName } from 'owa-folders';
import { confirm } from 'owa-confirm-dialog';
import strings from 'owa-strings/owa-mail-strings';
import { action, select } from 'satcheljs/lib/legacy';
import { createNewFolderService } from 'owa-folders';
import viewStateStore from '../store/store';
import { dismissMailFolderTextField } from './folderTextFieldActions';
import { lazyAddFolderIdToMoveToMruList } from 'owa-mail-move-mru';
import { showErrorMessage } from 'owa-mail-folder-store';
var SUCCESS = 'Success';
var ERROR = 'Error';
var ACCESS_DENIED_RESPONSE_CODE = 'ErrorAccessDenied';
export var createNewFolder = select({
    folderStore: function () { return folderStore; },
})(function createNewFolder(displayName, parentFolderId, state) {
    displayName = (displayName || '').trim(); // Do not allow whitespaces.
    // TODO: Task 522 - Implement "provisional folder" logic so that we don't need to wait for the server
    //   response before rendering the folder locally.
    if (displayName) {
        if (folderHasChildWithName(state.folderStore, displayName, parentFolderId)) {
            confirm(null, strings.folderWithNameAlreadyExists, false, // resolveImmediately
            { hideCancelButton: true });
            return Promise.resolve('');
        }
        else {
            return createNewFolderService(parentFolderId, displayName).then(function (responseMessage) {
                if (responseMessage.ResponseClass === SUCCESS) {
                    // add new folder to move-mru-list
                    lazyAddFolderIdToMoveToMruList.importAndExecute(responseMessage.Folders[0].FolderId.Id);
                    return addNewFolderToStore(state.folderStore, responseMessage, parentFolderId, displayName);
                }
                else if (responseMessage.ResponseClass === ERROR &&
                    responseMessage.ResponseCode === ACCESS_DENIED_RESPONSE_CODE) {
                    showErrorMessage(strings.cantCompleteRequestText, strings.notEnoughPermissionText);
                    return Promise.resolve('');
                }
                else {
                    throw new Error(responseMessage.MessageText);
                }
            });
        }
    }
    else {
        // No-op if there is no display name specified
        return Promise.resolve('');
    }
});
export var createNewFolderFromNewFolderTextField = select({
    viewState: function () { return viewStateStore.folderTextFieldViewState; },
})(action('createNewFolderFromNewFolderTextField')(function createNewFolderFromNewFolderTextField(displayName, markAsFavorite, state) {
    createNewFolder(displayName, state.viewState.folderId);
    dismissMailFolderTextField();
}));
//# sourceMappingURL=newFolder.js.map